import { StyleSheet } from 'react-native';
// Deliberately the colours module rather than the `themes` barrel. The barrel
// also loads `baseTheme`, which reaches into react-native-paper's MD3 theme,
// so importing it here would drag Paper into the module graph of every file
// that touches shared styles - and break any spec that stubs Paper down to the
// handful of components it actually uses.
import { Colors } from '../themes/colors';

/**
 * The default body-text colour, for a `<Text>` that would otherwise carry no
 * colour at all.
 *
 * This exists because "no colour" does not mean "inherit" on web.
 * react-native-web's base Text class hardcodes `color: rgb(0,0,0)`, and an
 * explicit colour only overrides it by arriving as a separate atomic class. So
 * a bare `<Text>Some label</Text>` renders literally black in every theme, and
 * turns invisible the moment the surface behind it goes dark.
 *
 * Reach for this only where a `<Text>` has no style of its own to put a colour
 * on. If it already has one, add `color` there instead - that keeps the colour
 * next to the rest of the element's styling rather than split across two props.
 *
 * A nested `<Text>` is the one case that genuinely does inherit (react-native-web
 * gives it `color: inherit`), so inline emphasis inside a coloured parent must
 * NOT use this: it would override the parent's colour instead of following it.
 */
export const textStyles = StyleSheet.create({
  default: {
    color: Colors.role.textStrong,
  },
});
